import axios from "axios";
import { Toast } from "vant";
import config from './config';
import store from '@/store';
import get_token from '@/utils/get_token';
import router from '@/router';

const public_config = config // 公共配置与拦截器参数重名了
//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时时间 单位是ms
  timeout: 10 * 1000,
  
});

let QueryList = {}

// 2.请求拦截器
service.interceptors.request.use(
  config => {
    if(public_config.WebOS == 'wx'){ // 微信环境下 设置请求头token
      config.headers['x-token'] = sessionStorage.getItem('x-token') 
    }
    
    config.params = config.params||{} // 初始化参数
    config.params['version'] = config.params.version || 'MOBILE'
    config.params['sms_code'] = sessionStorage.getItem('sms_code') //设置主消息id
    config.params['v_id'] = sessionStorage.getItem('v_id') // 设置店铺id
    config.params['r_id'] = sessionStorage.getItem('r_id'); //接收人id
    config.params['date_time'] = sessionStorage.getItem('date_time'); //分表表名时间
    config.params['last_time'] = sessionStorage.getItem('last_time'); //分表表名时间
    config.params['is_sub'] = sessionStorage.getItem('is_sub'); //区分是否是子账号
    config.params['all_param'] = sessionStorage.getItem('all_param'); //完整全部参数
    config.params['r_sub'] = sessionStorage.getItem('r_sub'); //判断是否需要分表
    
    // config.params['test'] = 1 // 测试代码
    
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    if (config.method == "post") {
      // 处理参数 如果是post请求 修改params参数为data 因为Vue-cli框架中axios参数根据method分为两种
      config["data"] = config["params"];
      delete config["params"];
    }
    // 默认存在加载loading, false时不显示加载loading
    if(!(config.show_loading==false)){
      QueryList[config.url] = config
      store.commit('Public/SHOW_LOADING',{data:true})
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
  
// 3.响应拦截器
service.interceptors.response.use(
  response => {
    // 微信环境下 token 无效时重新获取授权
    if((public_config.WebOS == 'wx')&&(response.data.code==1002||response.data.code==1003||response.data.code==1004)){
        get_token()
    }
    // 4010 4024 未绑定店铺 5013老板身份全部解绑
    if((response.data.code==4010|| response.data.code==4024 ) && (window.PATH_RECORD != 'NoBuildShop') ){ //提示后处理错误
      router.replace({name: 'NoBuildShop'})  
    }
    if(response.data.code==4016){
      Toast('您没有权限访问该页面');
    }
    // 判断是否关闭loading 默认关闭
    delete QueryList[response.config.url]
    
    // Toast(JSON.stringify( Object.keys(QueryList)));
    if(response.config.no_close_loading != true && Object.keys(QueryList).length==0 ){
      store.commit('Public/SHOW_LOADING',{data:false})
    }
    return response;
  },
  error => {
    // Toast('网络连接失败');
    /***** 处理结束 *****/
    //如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response);
  });
//4.导入文件
export default service;
